import { LadzoConsole as Lc } from "../global/ladzo-console.js";

function formatAddressFromSidlo(sidlo) {
  if (!sidlo) return "";

  let adresa = "";

  // Např. ulice: Mňukova
  if (sidlo.nazevUlice) {
    adresa += sidlo.nazevUlice + " ";
  }

  // Domovní číslo
  if (sidlo.cisloDomovni) {
    adresa += sidlo.cisloDomovni;
  }

  // Orientační číslo (např. /24)
  if (sidlo.cisloOrientacni) {
    adresa += "/" + sidlo.cisloOrientacni;
  }

  // Pokud není ulice, ale existuje textová adresa (např. pro místa bez ulice)
  if (!sidlo.nazevUlice && sidlo.textovaAdresa) {
    adresa = sidlo.textovaAdresa;
  }

  return adresa.trim();
}
export function nactiataniDatPresAres() {
  Lc.f("nactiataniDatPresAres");

  // Ošetření, pokud prvek #aAres neexistuje
  const $btn = $("#aAres");
  const formular = $btn.closest("form");

  const divHlaskaAres = formular.find(".dvAres");
  if ($btn.length === 0) {
    Lc.f("aAres nenalezen");
    return;
  }

  $btn.off("click").on("click", function (e) {
    e.preventDefault();

    divHlaskaAres.html("<span>Načítám data z ARES...</span>");

    const ico = formular.find(".dvIc .inpt").val();
    Lc.log("IČO pro ARES:", ico);

    $.ajax({
      url: "/ajax/ajax-ares.php",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: { ico: ico },
      cache: false,

      success: function (data) {
        Lc.log("json:", data);

        if (data) {
          // vyplnění hodnot (potvrdil jsi, že "confirm" nechceš používat)
          //formular.find(".dvDic .inpt").val(data.dic);
          formular.find('input.inpt[name="dic"]').val(data.dic);
          formular.find('input.inpt[name="firma"]').val(data.obchodniJmeno);

          formular
            .find('input.inpt[name="ulice"]')
            .val(formatAddressFromSidlo(data.sidlo));

          formular.find('input.inpt[name="mesto"]').val(data.sidlo.nazevObce);
          formular.find('input.inpt[name="psc"]').val(data.sidlo.psc);
          divHlaskaAres.text(
            "Název a sídlo firmy bylo vyplněno z databáze ARES."
          );
        } else {
          divHlaskaAres.html(
            "<em>Nepodařilo se najít IČO v databázi ARES, vyplňte údaje ručně.</em>"
          );
        }
      },

      error: function () {
        divHlaskaAres.html("<em>Chyba při komunikaci se serverem.</em>");
      },
    });
  });
}

export function upravStranku() {
  Lc.f("upravStranku - client_contact.js");
  nactiataniDatPresAres();
}
